import React, { useEffect, useState } from "react";
import styles from './scss/loginScreen.module.scss';
// import logofav from '../styles/images/logo192.svg';
// import logo from '../../../src/logo.svg';
// import eye from '../styles/images/eye.svg';
import { useHistory } from "react-router-dom";
import googlelg from '../../styles/images/googlelg.svg';
import applelg from '../../styles/images/applelg.svg';
import mslg from '../../styles/images/mslg.svg';
import { URButton } from "../../shared/widgets/button";
import { Modal, Tooltip } from "antd";
import { useForm } from "react-hook-form";
import { LoginService } from "../../base/loginService";
import { Cookie, decryptCodes, enablePermission, enablePermissionSafari, encryptCodes, getToken, setCookie } from "../../base/utils";
import { contactService } from "../../base/contactService";
import { contactSync, LoginState } from "../../models/model";
import { createCallConnection } from "../../base/callService/callService";
import { v4 as uuidv4 } from 'uuid';
import { Types } from "../../context/action/action";
import store from "../../context/store/store";
//import { SocketChatService } from "../../base/socketChatService";
//import HomeEncryption from "../../common/homeEncryption";
import { loadScreen } from "../../base/socketChatService/utils";
import { SocketChatService } from "../../base/socketChatService";
import { updateMeetingTotalBatch } from "../../base/meetingService/apiService";
import { determineIps, getWorktualAccess, storePlanValues } from "../../base/callService/common";
import { config } from '../../base/constant';

import jwt_decode from "jwt-decode";
import {
  LoginSocialApple,
  LoginSocialGoogle,
  LoginSocialMicrosoft
} from "reactjs-social-login";
import { GoogleLogin } from 'react-google-login';
import axios from "axios";

type LoginProps = {
  updateState: (state: string, email: any) => void;

}
type loginState = {
  Email: string;
  Password: string;
  Remember: boolean;
}
const Signin = ({ updateState }: LoginProps) => {
  const { register, setValue, getValues, setError, clearErrors, handleSubmit, formState: { errors } } = useForm();
  const [togglePass, setTogglePass] = useState<boolean>(false);
  const [errorLogIn, setErrorLogIn] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [pageLoader, setPageLoader] = useState(true);
  const [loginDetails, setLoginDetails] = useState<loginState>({
    Email: '', Password: "", Remember: false
  });
  const [provider, setProvider] = useState('');
  let { userdetails }: LoginState = store.getState().loginReducer;

  const [isModalVisible, setIsModalVisible] = useState('');
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  //const [startScreen, setStartScreen] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<any>('');
  const [error, setErrors] = useState<string>('');
  const [decodedDetails,setDecodedDetails] = useState([])
  const history = useHistory();
  const signupurl: string = `${config().ABOUT}pricing/`;
  let decode: any = {}
  //const watchAllFields = watch();
  const decodeJWT = async (data: any) => {

    var decoded = jwt_decode(data);

     setDecodedDetails(decoded);
    return decoded
  }

  const onSubmit = async (data: any, forceLogin: boolean = false) => {

    setLoading(true);
    setErrors('');
    console.log(error, "error");
    if (loginDetails.Remember) {
      //sessionStorage.setItem("logindetails", JSON.stringify(data));
    } else {
      sessionStorage.removeItem("logindetails");
      sessionStorage.removeItem("userinfo");
    }
    let userObject: any;
    if (!userDetails) {
      let uuidNew: any = uuidv4();
      if (!localStorage.getItem('deviceid')) {
        localStorage.setItem('deviceid', uuidNew);
      } else {
        uuidNew = localStorage.getItem('deviceid');
      }
      userObject = {
        "username": data?.Email ? data?.Email?.toLowerCase(): data.email,
        "password": data.Password? data.Password : data.password,
        "source": "Web",
        "deviceId": uuidNew,
        "ipAddress": '136.144.56.255:443',
        "loginCheck": "UCAAS",
        "location": "United Kingdom"
      };
    } else {
      userDetails.isForceLogin = true;
      userDetails.loginCheck = "UCAAS";
      userDetails.location = "United Kingdom";

    }
    try {
      await LoginService.createSSOToken(!userDetails ? userObject : userDetails).then(async (value: any) => {
        if (value && value.statusCode === 200) {
          if (value.is_ucas_user === 1) {
            Cookie.set('ssoToken', value.token, 365);
          store.dispatch({
            type: Types.ADD_TOKEN,
            payload: {
              token: value.token
            }
          });
          if (loginDetails.Remember) {
            let en_password = encryptCodes(data.Password, 'password');
            setCookie('Email_id', data.Email, 30);
            setCookie('passWord', en_password, 30);

          }
          setCookie('RememberMe', loginDetails.Remember, 30);
          //Cookie.set('ssoRefreshToken', value.refresh_token,365);


          const cookieData: any = Cookie.get();
          if (cookieData && cookieData?.["session"] && cookieData?.["session"] === 'redirect') {
            let meetingId = cookieData?.["meeting_id"]

            Cookie.deleteRedirectKey();
            setTimeout(() => {
              window.location.href = `${config().meetingDomain}/${meetingId}`;
            }, 2000)

            return true;
          }
          let decodeUserDetails: any = await decodeJWT(value.token);
          if (decodeUserDetails?.is_ucas_user === 1) {
            decodeUserDetails.sip_login_id = decodeUserDetails?.sip_login_id.toString();
            console.log(decodeUserDetails, "decodeUserDetails==");
            let sites: any = await getWorktualAccess(decodeUserDetails?.company_id);
            decodeUserDetails.purchasedAccess = sites;
            store.dispatch({
              type: Types.ADD_LOGIN,
              payload: {
                userdetails: decodeUserDetails
              }
            });
            if (decodeUserDetails?.client_domain) {
              store.dispatch({
                type: Types.SSO_TOKEN_CLIENT_DOMAIN,
                payload: {
                  clientDomain: decodeUserDetails.client_domain
                }
              });
            }
            // setStartScreen(false);
            storePlanValues();
            history.push('/home');
            loadScreen(true);
            // Cookie.set('ssoToken', value.token, 365);
            // setCookie('userinfo', JSON.stringify(decodeUserDetails), 365);
            sessionStorage.setItem("userinfo", JSON.stringify(decodeUserDetails));
            // contactService.getTeamContact();
            const userInfo = decodeUserDetails;
            console.log("Socket inital Authentication-----------", new Date())
            const service = new SocketChatService(userInfo?.sip_login_id, userInfo?.domain_id);
            service.sendMeetCallCheck();
            const queryParams: contactSync = { ext: userInfo.ext, CallId: uuidv4() };
            contactService.getWorkcontact(queryParams);
            /*   let ipDetails:any= await determineIps();
              createCallConnection(userInfo,ipDetails.IP);
              updateMeetingTotalBatch(); */
            setLoading(false);
            store.dispatch({
              type: Types.LANDING_PAGE,
              payload: {
                landingPage: true
              }
            });

            // let gotlAudio:any=false;
            // let gotlVideo:any=false;
            // let gotlNotify:any=false;
            // let permissionlMicroName = "microphone" as PermissionName;
            // let permissionlCameraName = "camera" as PermissionName;

            // await navigator.permissions.query({ name: permissionlMicroName })
            // .then(permissionStatus => {
            //     permissionStatus.state==='denied'?gotlAudio=false:permissionStatus.state==='granted'?gotlAudio=true:gotlAudio=false
            // });
            // await navigator.permissions.query({ name: permissionlCameraName })
            // .then(permissionStatus => {
            //     permissionStatus.state==='denied'?gotlVideo=false:permissionStatus.state==='granted'?gotlVideo=true:gotlVideo=false
            // });
            // if(gotlAudio!== true && gotlVideo!== true){
            if (navigator.userAgent.indexOf("Safari") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1) {
              enablePermissionSafari('login');
            }
            else {
              enablePermission('login');
            }

            //}
          } else {
            setLoading(false);
            setErrorLogIn('No account found. Please check and try again.')
            history.push('/login');
          }



          /*           await LoginService.getCurrentUser(history).then(async(data)=>{
          
                      if(data && data.user_info){
          
          
                        store.dispatch({
                          type: Types.ADD_LOGIN,
                          payload: {
                            userdetails: data.user_info
                          }
                        });
                        // setStartScreen(false);
                        history.push('/chats');
                        loadScreen(true);
                        Cookie.set('ssoToken', value.token,365);
                        setCookie('userinfo', JSON.stringify(data.user_info), 365);
                       
                        // contactService.getTeamContact();
                        const userInfo = data?.user_info;
                        const service = new SocketChatService(userInfo?.sip_login_id, userInfo?.domain_id);
                        const queryParams:contactSync = { ext: data.user_info.ext, CallId: uuidv4()};
                        contactService.getWorkcontact(queryParams);
                        let ipDetails:any= await determineIps();
                        createCallConnection(data.user_info,ipDetails.IP);
                        updateMeetingTotalBatch();
                        setLoading(false);
                        store.dispatch({
                          type: Types.LANDING_PAGE,
                          payload: {
                            landingPage: true
                          }
                        });
                      
                        // let gotlAudio:any=false;
                        // let gotlVideo:any=false;
                        // let gotlNotify:any=false;
                        // let permissionlMicroName = "microphone" as PermissionName;
                        // let permissionlCameraName = "camera" as PermissionName;
                       
                        // await navigator.permissions.query({ name: permissionlMicroName })
                        // .then(permissionStatus => {
                        //     permissionStatus.state==='denied'?gotlAudio=false:permissionStatus.state==='granted'?gotlAudio=true:gotlAudio=false
                        // });
                        // await navigator.permissions.query({ name: permissionlCameraName })
                        // .then(permissionStatus => {
                        //     permissionStatus.state==='denied'?gotlVideo=false:permissionStatus.state==='granted'?gotlVideo=true:gotlVideo=false
                        // });
                        // if(gotlAudio!== true && gotlVideo!== true){
                          if(navigator.userAgent.indexOf("Safari") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1)
                          {
                            enablePermissionSafari('login');
                          }
                          else{
                            enablePermission('login');
                          }
                         
                        //}
                      } else {
                        setLoading(false);
                      }
                    }).catch((err)=>{
                      setLoading(false);
                    }); */
          }else{
            setLoading(false);
            setErrorLogIn('No account found. Please check and try again.')
            history.push('/login');
          }
          
        } else if (value.statusCode === 422) {
          setLoading(false);
          if (value?.message) {
            setErrorLogIn(value?.message);
          }
        } else if (value.statusCode === 424) {
          // setIsModalVisible(value?.message);
          if (value?.message === "Your account is signed in from another device. Do you want to continue on this device?") {
            setUserDetails(userObject);
            setLoggedIn(true);
          }
        }
        updateMeetingTotalBatch();
      
    }).catch((e)=>{
      const respData = e.response.data;
      if(respData?.message){
        setErrorLogIn(respData?.message);
      }
      setLoading(false);
    });
  } catch(e) {
    setErrors('Authentication Failed');
    setLoading(false);
   
  }
  };
  useEffect(() => {
    if (loggedIn === true) {
      let dataRes = {
        "Email": userDetails?.username,
        "Password": userDetails?.password
      }
      setLoggedIn(false);
      onSubmit(dataRes, true);
    }

  }, [loggedIn]);
  useEffect(() => {
    const getCookie: any = getToken();
    setLoginDetails({ ...loginDetails, Remember: loginDetails.Remember })
    if (getCookie.RememberMe === "true") {
      let decry_password: any;
      setLoginDetails({ ...loginDetails, Remember: getCookie.RememberMe })
      if (getCookie.passWord) {
        decry_password = decryptCodes(getCookie.passWord, 'password');
      }
      setValue('Email', getCookie.Email_id, { shouldDirty: true });
      setValue('Password', decry_password, { shouldDirty: true });
      setLoginDetails({ ...loginDetails, Password: decry_password, Email: getCookie.Email_id, Remember: getCookie.RememberMe })
    }
  }, []);

  const handleOk = () => {
    setIsModalVisible('');
    setLoggedIn(false);
    onSubmit(userDetails, true);
    //console.log(loggedIn,"loggedIn");
  };

  const handleCancel = () => {
    setUserDetails('');
    setIsModalVisible('');
    setLoading(false);
  };

  const togglePassword = () => {
    setTogglePass(!togglePass);
  };
  const clearEmail = () => {
    setValue('Email', "", { shouldDirty: true });
    setError('Email', {
      type: "manual",
      message: "Required data missing"
    })
    setLoginDetails({ ...loginDetails, Email: "" });
    setErrorLogIn('')
  };

  const setEmailvaue = (e: any) => {
    setLoginDetails({ ...loginDetails, Email: e.target.value });
    setValue('Email', e.target.value?.trim(), { shouldDirty: true });
    clearErrors();
    setErrorLogIn('');
  }
  const SetNewPassword = (e: any) => {
    setLoginDetails({ ...loginDetails, Password: e.target.value });
    setValue('Password', e.target.value?.trim(), { shouldDirty: true });
    clearErrors();
    setErrorLogIn('');

  }

  const inputBoxFocus = (id: any) => {
    let inputBoxfocus: any = document.getElementById(id);
    inputBoxfocus.focus();
  }

  // let token: string = store.getState().loginReducer.token;
const socialLinkedAccount = async (data: any) => {
  let url = config().SOCIAL_MEDIA_MYACC_API;
  let body : any = {
    "email": data.social_account_email,
    "device_type": "",
    "browser": "",
    "login_type": ""

  };
  let token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImtyaXNobmFrdW1hci5zQHZlY3RvbmUuY29tIiwicGFzc3dvcmQiOiJrcmlzaG5hQDg2NiIsImRldmljZUlkIjoiMTU1LWhkbmRuLXdldXdpZWUiLCJzaXBMb2dpbklkIjoiNTM2NCIsInJvbGVJZCI6NCwiZG9tYWluSWQiOjMzMjgsImV4dCI6MjA5LCJjb21wYW55SWQiOjMzNjIsImVuZXRlcHJpc2VpZCI6ODAzMiwiaG9zdEFkZHJlc3MiOiI4MDMyLnVyY2hhdC51bmlmaWVkcmluZy5jby51ayIsIm9yZGVySWQiOjExMDE4LCJkaXJVc2VySWQiOjMyNjI0LCJpYXQiOjE2MjM3NTQ3ODd9.cR2-rh9bxex3riXVPlHW69gNRqZzDR8Tt6ewhuC9eXg";
  let headers:any = {
    appId: config().APPID,
    appSecret: config().AppSECRET,
    Authorization: token,
    "Content-Type": 'application/json'
  }
  const res = await axios.post(url,body,{headers}).then((res) => {

    if (res?.data?.results[0].v_errcode === 0) {
      data.email = res?.data?.results[0]?.my_acc_email;
      data.password = res?.data?.results[0]?.my_acc_password;

      onSubmit(data)
    } else if (res?.data?.results[0]?.v_errcode === -1) {
      setPageLoader(false);
      alert(res?.data?.results[0]?.v_errmsg);
    }
  }).catch((err) => {
    console.log("inserapierr", err)
  })
  return res;
}

const signup = () => {
  window.location.href = signupurl;
}


  return (
    <>
      <h1 className={styles.loginText}>Log in</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.signInBox}>
          <div className={styles.formLabel}>
            <label onClick={() => inputBoxFocus("email")} className={styles.inputLabel}>Email</label>
            <div className={`${styles.mailBox} ${errors.Email ? 'error' : ''}`}>
              <input placeholder="Enter your email address" className="mailBox" type="text" id="email" maxLength={64}
                autoFocus={true}
                {...register("Email", {
                  required: loginDetails.Password !== '' ? "Type your email address" : "Email address required", pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "Please enter a valid email address"
                  }
                })} onChange={setEmailvaue} />
              {(getValues('Email') || loginDetails.Email) && <span className={`icon_closefill 
              ${styles.showClear}`} onClick={clearEmail}></span>}
            </div>

            {errors.Email && <p className={styles.errorText}>{errors.Email.message}</p>}
          </div>

          <div className={styles.formLabel}>
            <label onClick={() => inputBoxFocus("password")} className={styles.inputLabel}>Password</label>
            <div className={`${styles.passwordBox} ${errors.Email ? 'error' : ''}`}>
              <input placeholder="Enter your Password" className="passwordBox" type={togglePass ? "text" : "password"} maxLength={30} id="password"
                value={loginDetails.Password}
                {...register("Password", {
                  required: loginDetails.Email !== '' ? "Type your password" : "Password required",
                  minLength: {
                    value: 5,
                    message: "Minimum length is 5"
                  }
                })} onChange={SetNewPassword} />
              <Tooltip mouseEnterDelay={0.5} placement="top" title={!togglePass ? "Show Password" : "Hide Password"}>
                {(getValues('Password') || loginDetails.Password) && <span onClick={togglePassword}
                  className={!togglePass ? "icon_Viewpassword shpass" : "icon_Fillpassword shpass"}></span>}</Tooltip>
            </div>

          </div>
          <div className={styles.customControl}>
            <div className={errors.Password ? `${styles.keepmeSec} ${styles.passError}` : `${styles.keepmeSec}`}>
              <div className={styles.radioCheck} onClick={() => setLoginDetails({ ...loginDetails, Remember: !loginDetails.Remember })}>

                <input className={`roundcheck ${styles.roundcheck}`}
                  type="checkbox"
                  checked={loginDetails.Remember}
                  placeholder="Remember"
                />
                <label className={styles.keepmeLabel}>Keep me logged in </label>
              </div>
              {errors.Password && <p className={styles.errorPass}>{errors.Password.message}</p>}
            </div>
            <p className={styles.forgetPwd}><a href="#/" onClick={() => updateState('forgot', loginDetails?.Email)}>Forgot Password?</a></p>
          </div>
          {errorLogIn && <div className={styles.errBox}>{errorLogIn}</div>}
          {/* {(decodedDetails?.is_ucas_user === 0) && <div className={styles.errBox}>No account found. Please check and try again.</div>} */}
          <URButton className={`btnSignin ${errorLogIn || errors.Email || errors.Password
            ? 'disabled' : ''}`} type="primary" htmlType="submit"
            name={loading ? "" : "Log In"} />

          <div className={styles.otherWays}>
            <span className={styles.otrText}>Or sign in with</span>
            <div className={styles.icnsList}>
             

            <div className={styles.googlecss}>
              {/* <GoogleLogin
                  clientId="785426237527-40g5faqoqa3kpluoo3ejtpupiuohiaqu.apps.googleusercontent.com"
                  buttonText=""
                  onSuccess={(data : any) => {
                    // console.log(data, "data");
                    const profile = data.getBasicProfile();
                      console.log(profile,"profile===");
                      // console.log('ID: ', profile.getId());
                      // console.log('Name: ', profile.getName());
                      // console.log('Image URL: ', profile.getImageUrl());
                      // console.log('Email: ', profile.getEmail());
                    data.company_id = userdetails?.company_id;
                    data.myaccount_email = userdetails?.Email;
                    data.social_account_email = data.profileObj.email;
                    data.social_account_type = "google";
                    setProvider(provider);
                    socialLinkedAccount(data,"")
                      }}
                      onFailure={(err:any) => {
                        console.log("error", err);
                      }}
                      cookiePolicy={'single_host_origin'} >   
              </GoogleLogin> */}
              <LoginSocialGoogle
                client_id="1097538180040-7gkto43okvr7t9mstomertgc7r476hli.apps.googleusercontent.com"
                scope="https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"
                redirect_uri="https://app.worktual.co.uk/home"

                onResolve={({provider,data} : any) => {
                if (data) {

                  data.company_id = userdetails?.company_id;
                  data.myaccount_email = userdetails?.Email;
                  data.social_account_email = data.email;
                  data.social_account_type = "google";

                  setProvider(provider);

                   socialLinkedAccount(data);
                } else {
                  console.error("Profile data not found in the response", data);
                }
              }
            }
              onReject={(err) => {
                console.log("Error during authentication", err);
              }}
            >
  {/* You can add a custom button or an SVG like you had previously */}
  <svg width="121" height="40" viewBox="0 0 121 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.557739" y="0.5" width="119" height="39" rx="3.5" fill="white" />
    <path d="M44.0577 20.2667C44.0577 19.2801 43.9759 18.56 43.7992 17.8135H32.3026V22.2667H39.0508C38.9149 23.3734 38.1802 25.0401 36.5475 26.16L36.5245 26.3092L40.1596 29.0688L40.4114 29.0935C42.7243 27 44.0577 23.9201 44.0577 20.2667Z" fill="#4285F4" />
    <path d="M32.3025 32C35.6086 32 38.3841 30.9334 40.4113 29.0934L36.5474 26.1599C35.5134 26.8667 34.1256 27.36 32.3025 27.36C29.0644 27.36 26.3162 25.2667 25.3365 22.3734L25.1929 22.3853L21.4132 25.252L21.3638 25.3866C23.3773 29.3066 27.5134 32 32.3025 32Z" fill="#34A853" />
    <path d="M25.3365 22.3734C25.0781 21.6267 24.9285 20.8267 24.9285 20.0001C24.9285 19.1734 25.0781 18.3733 25.323 17.6266L25.3162 17.4676L21.489 14.555L21.3639 14.6132C20.534 16.24 20.0577 18.0667 20.0577 20.0001C20.0577 21.9334 20.534 23.76 21.3639 25.3867L25.3365 22.3734Z" fill="#FBBC05" />
    <path d="M32.3025 12.64C34.6018 12.64 36.1529 13.6133 37.0372 14.4267L40.493 11.12C38.3705 9.18674 35.6086 8 32.3025 8C27.5134 8 23.3773 10.6933 21.3638 14.6132L25.3229 17.6266C26.3162 14.7334 29.0644 12.64 32.3025 12.64Z" fill="#EB4335" />
    <rect width="48" height="17" transform="translate(52.0577 11.5)" fill="white" />
    <path d="M60.067 18.5348C59.9709 18.2332 59.8416 17.9631 59.6792 17.7244C59.5201 17.4825 59.3295 17.277 59.1075 17.108C58.8854 16.9356 58.6318 16.8047 58.3468 16.7152C58.0651 16.6257 57.7552 16.581 57.4171 16.581C56.8437 16.581 56.3267 16.7285 55.866 17.0234C55.4053 17.3184 55.0407 17.7509 54.7722 18.321C54.5071 18.8878 54.3745 19.5821 54.3745 20.4041C54.3745 21.2294 54.5087 21.9271 54.7772 22.4972C55.0457 23.0672 55.4136 23.4998 55.8809 23.7947C56.3482 24.0897 56.8802 24.2372 57.4768 24.2372C58.0303 24.2372 58.5125 24.1245 58.9235 23.8991C59.3378 23.6738 59.6576 23.3556 59.883 22.9446C60.1117 22.5303 60.2261 22.0431 60.2261 21.483L60.6238 21.5575H57.7104V20.2898H61.7126V21.4482C61.7126 22.3033 61.5303 23.0457 61.1657 23.6754C60.8044 24.3018 60.304 24.7857 59.6643 25.1271C59.0279 25.4685 58.2987 25.6392 57.4768 25.6392C56.5554 25.6392 55.7467 25.4271 55.0506 25.0028C54.3579 24.5786 53.8177 23.977 53.4299 23.1982C53.0421 22.416 52.8482 21.4879 52.8482 20.4141C52.8482 19.602 52.9609 18.8729 53.1863 18.2266C53.4117 17.5803 53.7282 17.0317 54.1359 16.581C54.5468 16.1269 55.0291 15.7805 55.5826 15.5419C56.1394 15.3 56.7476 15.179 57.4072 15.179C57.9574 15.179 58.4694 15.2602 58.9434 15.4226C59.4207 15.585 59.8449 15.8153 60.2161 16.1136C60.5906 16.4119 60.9005 16.7666 61.1458 17.1776C61.3911 17.5852 61.5568 18.0376 61.643 18.5348H60.067ZM66.76 25.6547H63.2804L62.2645 25.3937C61.75 25.1538 61.4389 24.8365 61.3571 24.4406C61.2626 24.0448 61.5862 23.6696 62.0518 23.6473C62.4304 23.625 62.6468 23.9435 62.9398 24.0196L63.4097 24.2618L63.6819 24.6155L64.4311 24.4829C64.6402 24.2884 64.8476 24.1221 65.0589 23.9767C65.2689 23.8319 65.4647 23.7036 65.6308 23.5865C65.8097 23.4654 65.9707 23.3113 66.1335 23.1134C66.2992 22.9113 66.4411 22.7119 66.5468 22.5191C66.6528 22.3262 66.6723 22.1329 66.5943 21.9442L66.1441 21.1055C66.0714 20.7915 65.6843 20.7063 65.3716 20.7787C65.0569 20.8524 64.709 21.2275 64.4473 21.4455C64.1931 21.6631 64.0597 21.8501 64.0597 22.0339C64.0597 22.2391 64.2139 22.4592 64.5875 22.6434C64.9594 22.8265 65.4026 22.9606 65.8445 22.9606C66.2819 22.9606 66.6932 22.8242 67.0865 22.5729C67.4764 22.3215 67.7551 21.9953 67.8876 21.6124L68.2364 20.8999H66.2761L66.4035 20.1801H66.9482L67.2095 19.7891C67.3229 19.4576 67.4626 19.0669 67.6159 18.6321H66.7604Z" />
  </svg>
</LoginSocialGoogle>
              </div>
             <LoginSocialApple
                      client_id="com.worktual.app"
                      redirect_uri= {config().DOMAIN_URL}
                      onResolve={({ provider, data }: any) => {
                        const decodedToken: any = jwt_decode(data.authorization.id_token);
                        data.social_account_email = decodedToken.email;
                        data.company_id = userdetails?.company_id;
                        data.myaccount_email = userdetails?.Email;
                        data.social_account_type = "apple";
                        setProvider(provider);
                        socialLinkedAccount(data);
                      }}
                      onReject={(err:any) => {
                        console.log(err,"err");
                      }}
                    >
              <span><img src={applelg} alt="" /></span>  </LoginSocialApple>

              <LoginSocialMicrosoft
                  client_id="a6394062-20b4-494a-bac6-71572e2eb571"
                  redirect_uri={config().DOMAIN_URL}
                  onResolve={({ provider, data }: any) => {
                  const decodedToken: any = jwt_decode(data.access_token);
                  data.company_id = userdetails?.company_id;
                  data.myaccount_email = userdetails?.Email;
                  data.social_account_email = data.mail ? data.mail : decodedToken.email ? decodedToken.email : decodedToken.unique_name;
                  data.social_account_type = "microsoft";
                  setProvider(provider);
                  socialLinkedAccount(data);
                    }}
                    onReject={(err:any) => {
                      console.log("err", err);
                    }}
                      >
              <span><img src={mslg} alt="" /></span> </LoginSocialMicrosoft>
            </div>
            <div className={styles.newToSection}>
              New to Worktual? <span className={styles.linkSignup} onClick={signup}>Sign Up</span>
            </div>
          </div>
        </div>
        <Modal title="Already Logged In" visible={isModalVisible ? true : false} okText="Yes" cancelText="No" onOk={handleOk} onCancel={handleCancel}>
          <p>{isModalVisible}</p>
        </Modal>
      </form>
      {/* {startScreen  && <HomeEncryption/>} */}
    </>
  );
};

export default Signin;